import React, {Component} from 'react';
import {Col} from "mdbreact";
import {Link} from "react-router-dom";
import { IMAGE_URL} from "./../../config/Config";

export default class MerchantsCat extends Component {

    render() {
        const { catId,image,name } = this.props;
        return (
            <Col xs="6" md="3" className="text-center">
                <Link to={"/merchants/"+catId} className="svg-category ">
                    <img src={IMAGE_URL+image} alt={name} className="img-fluid home-cat-image" />
                </Link>
            </Col>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/merchants/MerchantsCat.js